export const handleSort = (field, currentSortField, currentSortOrder, setSortField, setSortOrder) => {
  if (field === currentSortField) {
    setSortOrder(currentSortOrder === 'asc' ? 'desc' : 'asc');
  } else {
    setSortField(field);
    setSortOrder('asc');
  }
};

export const handleSortIssue = (field, currentSortFieldIssue, currentSortOrderIssue, setSortFieldIssue, setSortOrderIssue) => {
  if (field === currentSortFieldIssue) {
    setSortOrderIssue(currentSortOrderIssue === 'asc' ? 'desc' : 'asc');
  } else {
    setSortFieldIssue(field);
    setSortOrderIssue('asc');
  }
};
